module.exports = __webpack_public_path__ + "static/media/black-configure-data-symbols-icon.2b34b00a.svg";